import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { AlertStyle, EmptyIcon } from './styles';
import { RcAlertClasses } from './utils';
var _RcAlert = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcAlert' });
    var icon = props.icon, classesProp = props.classes, children = props.children, align = props.align, size = props.size, rest = __rest(props, ["icon", "classes", "children", "align", "size"]);
    var classes = combineClasses(RcAlertClasses, classesProp);
    return (React.createElement(MuiAlert
    // * no icon in current design
    , __assign({ 
        // * no icon in current design
        icon: icon === true ? undefined : icon !== null && icon !== void 0 ? icon : EmptyIcon }, rest, { ref: ref, classes: classes }), children));
});
var RcAlert = styled(_RcAlert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), AlertStyle);
RcAlert.defaultProps = {
    severity: 'info',
    size: 'medium',
    align: 'left',
    square: true,
};
RcAlert.displayName = 'RcAlert';
export { RcAlert };
var templateObject_1;
